var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-btn',{staticClass:"q-pa-md fit bg-white",attrs:{"icon":"add_circle","outline":"","label":_vm.label,"to":_vm.to,"color":_vm.color},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }